import React, { ChangeEvent, useContext } from "react";
import { useTranslation } from "react-i18next";

import { PnoSouscriptionContexte } from "views/PolicePno/Souscription";
import Typography from "@material-ui/core/Typography";
import { Radio } from "@/views/PolicePno/Souscription/FormulaireElements/Radio";
import { Maison } from "@/views/PolicePno/Souscription/Etapes/TypeBien/Maison";
import { Appartement } from "@/views/PolicePno/Souscription/Etapes/TypeBien/Appartement";
import { Garage } from "@/views/PolicePno/Souscription/Etapes/TypeBien/Garage";
import { LocalCommercial } from "@/views/PolicePno/Souscription/Etapes/TypeBien/LocalCommercial";
import { BoutonRetour } from "@/views/PolicePno/Souscription/BoutonRetour";
import { BoutonSuivant } from "@/views/PolicePno/Souscription/BoutonSuivant";
import { Souscription } from "@/types/Souscription";
import { TypeBienEnum } from "@/types/TypeBien";

type getTypeOriginalDepuisPartial<T> = T extends Partial<infer U> ? U : never;
type Adresse = getTypeOriginalDepuisPartial<
  Souscription["data"]["contractAddress"]
>;

export const TypeBien = () => {
  const { dataSouscription, setDataSouscription } = useContext(
    PnoSouscriptionContexte
  );
  const { t } = useTranslation();

  const typeBien = dataSouscription.data?.housingType;

  const onChangeTypeBien = (e: ChangeEvent<HTMLInputElement>) => {
    const newData = e.target.value;
    setDataSouscription({
      ...dataSouscription,
      data: {
        ...dataSouscription.data,
        housingType: newData,
        furnished: undefined,
        area: undefined,
        numberOfPrincipalRooms: undefined,
        floor: undefined,
        typeActivite: undefined,
        monument: undefined,
        contractAddress: {
          ...dataSouscription.data?.contractAddress,
          residency: "",
          lotNumber: "",
          building: "",
          buildingNumber: "",
        } as unknown as Adresse,
      },
    });
  };

  return (
    <>
      <Typography variant="h6">{t("pno.detailsBien")}</Typography>
      <section>
        <div>
          <Radio
            value={typeBien || ""}
            items={[
              { label: t("pno.maison"), value: TypeBienEnum.MAISON },
              {
                label: t("pno.appartement"),
                value: TypeBienEnum.APPARTEMENT,
              },
              {
                label: t("pno.localCommercial"),
                value: TypeBienEnum.LOCAL_COMMERCIAL,
              },
              { label: t("pno.garage"), value: TypeBienEnum.GARAGE },
            ]}
            onChange={onChangeTypeBien}
          />
        </div>
        {typeBien === TypeBienEnum.MAISON && <Maison />}
        {typeBien === TypeBienEnum.APPARTEMENT && <Appartement />}
        {typeBien === TypeBienEnum.LOCAL_COMMERCIAL && <LocalCommercial />}
        {typeBien === TypeBienEnum.GARAGE && <Garage />}
        <div>
          <BoutonRetour />
          <BoutonSuivant />
        </div>
      </section>
    </>
  );
};
